import { splitLocale } from '../../locale/localeUtils';
export const fontWordBreakTokens = () => {
  return 'unset';
};
export const fontWordBreakTokensNova = language => {
  // Split the locale into language, region, and script. Our font family designations contain different combinations of these aspects of the locale.
  const {
    lang
  } = splitLocale(language);
  switch (lang) {
    case 'zh':
    case 'ja':
    case 'ko':
    case 'th':
      return 'keep-all';
    case 'ar':
    default:
      return 'normal';
  }
};
//# sourceMappingURL=fontWordBreak.js.map